import { render, staticRenderFns } from "./send-resupply-v2.modal.vue?vue&type=template&id=ee127604&scoped=true"
import script from "./send-resupply-v2.modal.vue?vue&type=script&lang=js"
export * from "./send-resupply-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./send-resupply-v2.modal.vue?vue&type=style&index=0&id=ee127604&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee127604",
  null
  
)

export default component.exports